// extracted by mini-css-extract-plugin
module.exports = {"empty-result":"empty-result-ggC7d","emptyResult":"empty-result-ggC7d"};